import React from 'react';
import Navigation from './Navigation';
import Footer from './Footer';

const Privacy = () => {
  return (
    <>
    <Navigation />

    <div className="min-h-screen bg-gray-50 font-sans ">
      {/* Vibrant Header Section */}
      <div className="bg-gradient-to-r from-purple-600 via-indigo-600 to-blue-500 py-16 px-4 sm:px-6 lg:px-8 text-center text-white shadow-lg">
        <h1 className="text-4xl font-extrabold tracking-tight sm:text-5xl mb-4 pt-20">
          Privacy Policy
        </h1>
        <p className="text-lg text-indigo-100 max-w-2xl mx-auto">
          We value your trust and are committed to protecting your personal information.
        </p>
        <p className="mt-4 text-sm text-indigo-200 uppercase tracking-widest font-semibold">
          Last Updated: August 11, 2025
        </p>
      </div>

      {/* Main Content Container */}
      <div className="max-w-4xl mx-auto -mt-10 px-4 sm:px-6 lg:px-8 pb-16 relative z-10">
        <div className="bg-white rounded-2xl shadow-xl p-8 sm:p-12 border border-gray-100">
          
          <div className="prose prose-lg prose-indigo max-w-none text-gray-600">
            <p className="lead text-xl text-gray-700 mb-8">
              This Privacy Policy describes Our policies and procedures on the collection, use, and disclosure of Your information when You use the Service and tells You about Your privacy rights and how the law protects You.
            </p>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4 border-l-4 border-indigo-500 pl-4">
                1. Information We Collect
              </h2>
              <p className="mb-4">
                We collect several different types of information for various purposes to provide and improve our Service to you.
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li><strong className="text-gray-900">Personal Data:</strong> Email address, First name and last name, Phone number, Address, etc.</li>
                <li><strong className="text-gray-900">Usage Data:</strong> Internet Protocol (IP) address, browser type, browser version, the pages of our Service that you visit.</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4 border-l-4 border-indigo-500 pl-4">
                2. Use of Data
              </h2>
              <p className="mb-4">
                We use the collected data for various purposes, including but not limited to:
              </p>
              <ul className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <li className="bg-gray-50 p-4 rounded-lg border border-gray-100 flex items-start">
                  <span className="text-indigo-500 mr-2">✓</span> To provide and maintain our Service
                </li>
                <li className="bg-gray-50 p-4 rounded-lg border border-gray-100 flex items-start">
                  <span className="text-indigo-500 mr-2">✓</span> To notify you about changes to our Service
                </li>
                <li className="bg-gray-50 p-4 rounded-lg border border-gray-100 flex items-start">
                  <span className="text-indigo-500 mr-2">✓</span> To provide customer support
                </li>
                <li className="bg-gray-50 p-4 rounded-lg border border-gray-100 flex items-start">
                  <span className="text-indigo-500 mr-2">✓</span> To monitor the usage of our Service
                </li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4 border-l-4 border-indigo-500 pl-4">
                3. Cookies and Tracking
              </h2>
              <p>
                We use cookies and similar tracking technologies to track the activity on Our Service and store certain information. You can instruct Your browser to refuse all cookies or to indicate when a cookie is being sent.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4 border-l-4 border-indigo-500 pl-4">
                4. Third-Party Services
              </h2>
              <p>
                We may employ third-party companies and individuals due to the following reasons: to facilitate our Service, to provide the Service on our behalf, or to assist us in analyzing how our Service is used. These third parties have access to your Personal Data only to perform these tasks on our behalf.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4 border-l-4 border-indigo-500 pl-4">
                5. Contact Us
              </h2>
              <p className="mb-4">
                If you have any questions about this Privacy Policy, You can contact us:
              </p>
              <div className="bg-indigo-50 p-6 rounded-xl inline-block">
                <p className="font-medium text-indigo-900">📧 By email: support@instashortlist.com</p>
              </div>
            </section>

          </div>
        </div>
      </div>
    </div>
    
    <Footer/>
    </>
  );
};

export default Privacy;